<template>
  <div class="aside aside-left aside-fixed d-flex flex-column flex-row-auto" :class="{ 'aside-on': isOnAside }">
    <div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu min-h-lg-800px"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        :class="asideMenuClass"
      >
        <perfect-scrollbar class="aside-menu scroll position-relative" style="max-height: 90vh">
          <Menu />
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<script setup>
import Menu from "@/view/layout/aside/Menu.vue";
import { useClassesStore } from "@/core/store/config/classesStore";
import useLayoutStore from "@/core/store/layout/layoutStore";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const store = useLayoutStore();
const { isOnAside } = storeToRefs(store);
const { getClasses } = useClassesStore();

const asideMenuClass = computed(() => {
  const classes = getClasses("aside_menu");

  if (classes.length) {
    return classes.join(" ");
  }
  return null;
});
</script>
